var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "mb-0 px-5" },
        [
          _c("BatchFormField", {
            attrs: { name: "Subasta" },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function() {
                  return [
                    _vm._v(
                      " #" +
                        _vm._s(_vm.batch.subasta.folio) +
                        " del " +
                        _vm._s(_vm.formatDate(_vm.batch.subasta.fechaSubasta)) +
                        " "
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm.batch.loteadora.nombre
            ? _c("BatchFormField", {
                attrs: { name: "Aduana Loteadora" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function() {
                        return [_vm._v(_vm._s(_vm.batch.loteadora.nombre))]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1176268375
                )
              })
            : _vm._e(),
          _vm.batch.subasta.gestora.fantasia
            ? _c("BatchFormField", {
                attrs: { name: "Aduana Coordinadora" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _vm._v(_vm._s(_vm.batch.subasta.gestora.fantasia))
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2808009526
                )
              })
            : _vm._e(),
          _c("BatchFormField", {
            attrs: { "data-cy": "minimum-amount", name: "Monto mínimo" },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function() {
                  return [
                    _vm._v(
                      "$ " + _vm._s(_vm._f("amount")(_vm.batch.montoMinimo))
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c("vs-divider"),
          _c(
            "b-form",
            {
              attrs: { "data-vv-scope": "adjudge-form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-8 m-auto text-right mb-3" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          size: "sm",
                          "data-cy": "new-adjudge-button"
                        },
                        on: { click: _vm.newBidderInAdjudge }
                      },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "PlusIcon", size: "12" }
                        }),
                        _vm._v(" Nuevo adjudicatario ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _vm.showList
                  ? _c(
                      "div",
                      { staticClass: "col-8 m-auto" },
                      [
                        !_vm.bidder
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                " Por favor selecciona un adjudicatario de la lista "
                              )
                            ])
                          : _vm._e(),
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true },
                              expression: "{ required: true }"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            label: "Búsqueda de adjudicatario",
                            autocomplete: "off",
                            "data-vv-as": "adjudicatario",
                            danger: _vm.errors.has(
                              "adjudge-form.adjudicatarioId"
                            ),
                            "danger-text": _vm.errors.first(
                              "adjudge-form.adjudicatarioId"
                            ),
                            name: "adjudicatarioId"
                          },
                          on: {
                            keyup: function($event) {
                              return _vm.searchForBidders()
                            }
                          },
                          model: {
                            value: _vm.bidderQuery,
                            callback: function($$v) {
                              _vm.bidderQuery = $$v
                            },
                            expression: "bidderQuery"
                          }
                        }),
                        _vm.searching
                          ? _c("span", { staticClass: "muted-light" }, [
                              _vm._v("Buscando...")
                            ])
                          : _vm._e(),
                        _vm.successfulBidders.length
                          ? _c(
                              "ul",
                              {
                                attrs: { "data-cy": "bidder-list", id: "list" }
                              },
                              _vm._l(_vm.successfulBidders, function(item) {
                                return _c(
                                  "li",
                                  {
                                    key: item.adjudicatarioId,
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.confirmBidder(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [_vm._v(_vm._s(item.nombre))]),
                                    _c("span", { staticClass: "muted-light" }, [
                                      _vm._v(" " + _vm._s(item.rut) + " ")
                                    ]),
                                    _c("p", [
                                      _c("b", [_vm._v(_vm._s(item.correo))]),
                                      _vm._v(
                                        " (" +
                                          _vm._s(item.ciudad) +
                                          ", " +
                                          _vm._s(item.comuna) +
                                          ")"
                                      )
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm.error.adjudicatarioId
                          ? _c("small", { staticClass: "text-danger" }, [
                              _vm._v(
                                " " + _vm._s(_vm.error.adjudicatarioId) + " "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.bidder && !_vm.showList
                  ? _c(
                      "div",
                      {
                        staticClass: "col-8 m-auto",
                        staticStyle: { cursor: "pointer" }
                      },
                      [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.showList = true
                              }
                            }
                          },
                          [
                            _c("small", [_vm._v(" Adjudicatario ")]),
                            _c("div", [
                              _vm._v("Nombre: "),
                              _c("strong", [_vm._v(_vm._s(_vm.bidder.nombre))])
                            ]),
                            _c("div", [
                              _vm._v("Rut: " + _vm._s(_vm.bidder.rut))
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-8 mt-3 m-auto" },
                  [
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true, regex: /^([0-9]+)$/ },
                          expression: "{ required: true, regex: /^([0-9]+)$/ }"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        label: "Monto de adjudicación",
                        type: "number",
                        danger: _vm.errors.has("adjudge-form.amount"),
                        "danger-text": _vm.errors.first("adjudge-form.amount"),
                        name: "amount"
                      },
                      model: {
                        value: _vm.amount,
                        callback: function($$v) {
                          _vm.amount = $$v
                        },
                        expression: "amount"
                      }
                    }),
                    !_vm.bidder
                      ? _c("span", { staticClass: "text-primary" }, [
                          _vm._v(" Por favor ingresa un monto sin decimales ")
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-8 mt-3 m-auto" },
                  [
                    _c("div", { staticClass: "mb-3 ml-2" }, [
                      _c("small", [_vm._v("Fecha máxima de pago")])
                    ]),
                    _c(
                      "b-form-group",
                      [
                        _c("date-picker", {
                          staticClass: "w-100",
                          attrs: {
                            placeholder: "Fecha máxima de pago",
                            format: "DD MMM YYYY",
                            "value-type": "YYYY-MM-DD",
                            type: "date",
                            name: "latestPaymentDate",
                            "data-cy": "fecha-maxima-pago"
                          },
                          model: {
                            value: _vm.latestPaymentDate,
                            callback: function($$v) {
                              _vm.latestPaymentDate = $$v
                            },
                            expression: "latestPaymentDate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 text-center  mt-10" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "success", "data-cy": "next-button" },
                        on: {
                          click: function($event) {
                            return _vm.create()
                          }
                        }
                      },
                      [_vm._v(" Generar comprobante de adjudicación ")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "newBidderInAdjudge",
          attrs: {
            title: "Nuevo adjudicatario",
            "no-close-on-backdrop": "",
            size: "sm",
            "hide-footer": ""
          }
        },
        [
          _c("NewBidderInAdjudgeForm", {
            on: { "bidder-save": _vm.handleBidderSave }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }